export default {
    created() {
        let currentLanguage = this.getLocale();
        this.$i18n.locale = currentLanguage;
        this.afterCreated()
    },
    methods: {
        afterCreated() {

        },
        getLocale() {
            const lang = (navigator.language || "").toLowerCase();
            console.log('getlocale===>', lang)
            if (lang === "pt" || lang === "pt-br" || lang === "pt-pt") {
                return "pt";
            } else if(lang === "zh-TW".toLowerCase()) { //10
                return "cn_TW"
            } else if (lang.indexOf('fr') > -1) { //3
                return "fr";
            } else if (lang.indexOf('de') > -1) { // 1
                return "de";
            } else if (lang.indexOf('it') > -1) { // 4
                return "it";
            } else if (lang.indexOf('ja') > -1) { // 5
                return "ja";
            } else if (lang.indexOf('es') > -1) { // 9
                return "es";
            } else if (lang.indexOf('ru') > -1) { // 7
                return "ru";
            }
            return "en"; // 2

            // zh cn_TW   fr de it ja    es   ru en
            //      tw    fr de it jp pt sp   ru en
            //
        }
    }
}
